// extracted by mini-css-extract-plugin
export var hintContainer = "survey-hint-module--hint-container--dPRCO";
export var hintHeading = "survey-hint-module--hint-heading--35Ov+";
export var questionMark = "survey-hint-module--question-mark--RDpH3";
export var surveyHint = "survey-hint-module--survey-hint--gbED7";
export var surveyHintWrapper = "survey-hint-module--survey-hint-wrapper--dE4nQ";